import { motion } from "framer-motion";

const IMG_1 = "/assets/gallery/rack.jpg";
const IMG_2 = "/assets/gallery/kettlebells.jpg";

const reveal = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
};

export default function Manifesto() {
  return (
    <section id="method" className="relative py-24 md:py-40 border-b border-white/10" data-testid="manifesto-section">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14 items-start">
          <motion.div {...reveal} transition={{ duration: 0.7 }} className="md:col-span-5 relative">
            <div className="clip-frame overflow-hidden bg-black">
              <img src={IMG_1} alt="Squat rack, bench and Olympic bars on the training floor at OSHPerformance gym, Northwood" className="w-full h-[420px] md:h-[560px] object-cover hover:scale-105 transition-transform duration-700" data-testid="manifesto-image-1" />
            </div>
          </motion.div>

          <motion.div {...reveal} transition={{ duration: 0.7, delay: 0.15 }} className="md:col-span-7 md:pt-8">
            <p className="font-display uppercase tracking-[0.3em] text-xs text-gold mb-6">About Harry</p>
            <h2 className="font-display font-bold uppercase leading-[0.9] text-5xl md:text-7xl mb-8" data-testid="manifesto-heading">
              Built For <span className="text-gold italic">Real Life</span>
            </h2>
            <div className="space-y-5 text-zinc-400 text-base md:text-lg leading-relaxed max-w-2xl" data-testid="manifesto-description">
              <p>
                I'm Harry, a personal trainer based in Northwood. I train busy parents, hard
                workers, the older generation and athletes — real people with real lives — and
                help every one of them reach their goals.
              </p>
              <p>
                What I do is simple: strength training, rehabilitation, better movement and
                athletic performance. Every client starts with a one-to-one assessment of how they
                move and where they want to get to, then follows a programme I build entirely
                around them — scaled to their body, their history and the time they actually have.
              </p>
              <p>
                Sessions are one-to-one with me, progress is tracked week by week, and the plan
                adapts as you do. No gimmicks, no guesswork — just consistent, targeted work that
                adds up to real change.
              </p>
            </div>
            <div className="mt-10 border-l-2 border-gold pl-6" data-testid="intent-quote">
              <p className="font-display font-semibold uppercase text-2xl md:text-3xl leading-tight text-white">
                Intentional training comes first — <span className="text-gold italic">every rep has a reason.</span>
              </p>
              <p className="text-zinc-500 text-sm mt-3">Nothing random. Nothing wasted. Every session moves you closer to your target.</p>
            </div>
          </motion.div>
        </div>

        <motion.div {...reveal} transition={{ duration: 0.7 }} className="mt-16 md:mt-24 md:ml-auto md:w-1/3">
          <div className="clip-frame-alt overflow-hidden bg-black">
            <img src={IMG_2} alt="Kettlebell rack and medicine ball at OSHPerformance personal training gym Northwood" className="w-full h-64 md:h-80 object-cover object-[center_60%] hover:scale-105 transition-transform duration-700" data-testid="manifesto-image-2" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
